export default __webpack_public_path__ + "static/media/img-profile-bg.2b15e931.png";